export const formatCurrency = ( value ) => {

    const numValue = typeof value === 'string' ? parseFloat( value ) : value;

    if ( isNaN( numValue ) ) return '';

    return numValue.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

}